import { HttpService, Repository, RepositoryBase, TaggedUrl, Tags, Weaver } from '@skylab-shared/core';
import { CurrencyModel } from '@skylab-shared/dataModel';
import { pickBy } from '@skylab-shared/utils';
import { CurrencyBO } from './currency.bo';

@Repository({
    boType: CurrencyBO,
    apiController: TaggedUrl.join('system/currencies', [Tags.Api])
})
export class CurrencyRepositoryBase extends RepositoryBase<CurrencyBO, CurrencyModel> {
    public constructor(
        http: HttpService,
        private weaver: Weaver
    ) {
        super(http);
    }

    protected createBO(): CurrencyBO {
        return new CurrencyBO(this.weaver);
    }

    protected async preparePlainObjectAsync(model: CurrencyModel) {
        return {
            id: model.id,
            version: model.version,
            sun: model.sun,
            default: model.default,
            name: model.name,
            precision: model.precision,
            symbol: model.symbol,
            externalId: model.externalId
        };
    }

    protected async fromPlainObjectAsync(item: any): Promise<CurrencyModel> {
        return new CurrencyModel(pickBy({
            id: item.id,
            version: item.version,
            sun: item.sun,

            default: item.default,
            name: item.name,
            precision: item.precision,
            symbol: item.symbol,
            externalId: item.externalId
        }, val => val !== void 0));
    }
}
